import { defineStore } from 'pinia'
import api from '@/Util/api'

export default defineStore("auth", {
  state: ()=>({
    cms: {},
    loginToken: null,
    currentUser: null,
    currentLogin: null,
    loginValidated: false,
    typeDesc: {},
    localizations: {},
    environment: {},
    currentLocalization: {},
    pageTemplates: {},
    currentClient: null,
  }),
  getters: {
    isLoggedIn() {
      return !!this.currentUser
    },
  },
  actions: {
    async loadCurrentUser() {
      if (this.loginToken) {
        var response=await api.root();
        this.cms=response.cms;
        this.currentUser=response.user;
        this.currentLogin=response.login;
        this.loginValidated=true;
        this.environment=response.environment;
        this.typeDesc=response.typeDesc;
        this.localizations=response.localizations;
        this.pageTemplates=response.pageTemplates;
        if (!this.currentUser)
          setTimeout(()=>this.logout(), 16);
      } else {
        this.loginValidated=true;
        setTimeout(()=>this.logout(), 16);
      }
    },
    loadStoredToken() {
      this.loginToken=localStorage.getItem("icmsLogin", "")
      if (this.loginToken)
        this.loadCurrentUser()
      else {
        this.loginValidated=true;
        setTimeout(()=>this.loginValidated=false, 16);
      }
    },
    async login(token) {
      localStorage.setItem("icmsLogin", token)
      this.loginToken=token;

      if (this.loginToken)
        await this.loadCurrentUser()
    },
    logout() {
      localStorage.removeItem("icmsLogin");
      this.loginToken=null;
      this.currentUser=null;
      this.loginValidated=false;
    },
  },
});
